import { render, staticRenderFns } from "./SameProductCard.vue?vue&type=template&id=1f215ee4&scoped=true&"
import script from "./SameProductCard.vue?vue&type=script&lang=js&"
export * from "./SameProductCard.vue?vue&type=script&lang=js&"
import style0 from "./SameProductCard.vue?vue&type=style&index=0&id=1f215ee4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f215ee4",
  null
  
)

export default component.exports